<template>
  <!--弹窗-->
  <div class="popup_center">
    <div class="select"
      @click="choiceNav">
      <span>{{ navlist[navlistIndex].name }}</span>
      <i></i>
      <em class="line"></em>
    </div>
    <div class="select-popup"
      :class="{'select-popup-show' : selectPopupHide}">
      <div v-for="(item,index) in navlist"
        :key="index"
        :class="{active: item.active}"
        @click.stop="activeItem(index,item)">
        {{item.name}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popupCenter',
  data () {
    return {
      selectPopupHide: true,
      navlistIndex: 0
    }
  },
  props: {
    navlist: {
      default () {
        return [
          {
            name: '全部',
            value: 3,
            active: true
          },
          {
            name: '体检',
            value: 1,
            active: false
          },
          {
            name: '机构',
            value: 2,
            active: false
          }
        ]
      }
    }
  },
  methods: {
    choiceNav () {
      if (window.location.href.indexOf('/search') === -1) {
        return
      }
      this.selectPopupHide = false
    },

    activeItem (index, item) {
      this.hideSelect(item)
      if (this.navlistIndex == index) {
        return
      }
      for (let i = 0; i < this.navlist.length; i++) {
        if (this.navlist[i].value != item.value) {
          this.$set(this.navlist[i], 'active', false)
        } else {
          this.$set(this.navlist[i], 'active', true)
        }
      }
      this.navlistIndex = index
      this.$emit('closePopupCenter', item)
    },

    hideSelect (item) {
      this.selectPopupHide = true
    }
  },
  mounted () {
    var vm = this
    $(document).click(function () {
      if (!vm.selectPopupHide) {
        vm.selectPopupHide = true
      }
    })
  },
  watch: {}
}
</script>

<style lang="less" scoped>
@import "../../assets/css/variable.less";
.popup_center {
  position: relative;
  .select {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 30/200rem;
    span {
      color: #484848;
      font-size: 28/200rem;
    }
    i {
      height: 0;
      width: 0;
      border-top: 9/200rem solid #484848;
      /*此处将左右的边框设置为透明色*/
      border-right: 8/200rem solid transparent;
      border-left: 8/200rem solid transparent;
    }
    .line {
      height: 40/200rem;
      width: 1px;
      background-color: #dedede;
    }
  }
  .select-popup {
    font-size: 28/200rem;
    position: absolute;
    border: solid 1px #eee;
    top: 30/100rem;
    box-shadow: 0rem 4/100rem 14/100rem 0rem rgba(0, 0, 0, 0.12);
    padding: 0 20/200rem 0 30/200rem;
    width: 170/200rem;
    background-color: #fff;
    transform: translate3d(0, 0, 0);
    transition: all 0.3s;
    visibility: visible;
    opacity: 1;
    & > div {
      line-height: 100/200rem;
      border-bottom: solid 1px #dedede;
    }
    .active {
      color: @color-theme;
    }
    & > div:last-child {
      border-bottom: none;
    }
  }

  .select-popup-show {
    visibility: hidden;
    opacity: 0;
    transform: translate3d(0, -10/100rem, 0);
  }

  .select-popup:before {
    display: inline-block;
    width: 0;
    height: 0;
    border: solid transparent;
    border-width: 5/100rem;
    border-bottom-color: #fff;
    content: "";
    position: absolute;
    top: -10/100rem;
    left: 20/100rem;
  }
}
</style>
